<template>
    <zen-one
    :showuserinfo="false"
    title="Pengurusan -  Ibayaq"
    :crumbs="crumbs"
    >
    <z-page
    title="Pengurusan Ibayaq - Perkhidmatan Kami"
    >
  
    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-light1--bg white">
      <template #title>
        Banner
      </template>
  
      <w-form
        ref="form"
        v-model="dialog.valid"
        @validate="submitContent"
        @success="success"
      >
      <template v-if='form.url'><img :src="form.url" height="200" width="400"></template>
        <w-input
            class="mt3"
            v-model="form.path"
            required
            label="Pautan"
            :validators="[validators.required]">
        </w-input>
        <br>
        <w-input
            type="file"
            label="File *"
            v-model="files"
            :validators="[validators.required]"
            accept=".jpg, .jpeg, .png, .gif, .svg"
        />
        <i style="color: red">* Maksimum saiz fail 2MB</i>
        <br>
        <br>
        <w-switch class="mr6" v-model="form.status" label="Aktif"></w-switch>

      </w-form>
  
  
      <template #actions>
        <div class="spacer" />
        <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
        <w-button
        class="ml1"
        :loading="dialog.loading"
        @click="$refs.form.validate()"
        >
          Simpan
        </w-button>
      </template>
  
  
    </w-dialog>
  
    <z-table
      ref="tbluser"
      title="Senarai Perkhidmatan Kami"
      :headers="table.headers"
      :items="table.items"
      :meta="table.meta"
      class="white--bg"
    >
  
      <template #button>
        <w-button
        dark
        class="indigo-dark2--bg ml1 fs-2"
        @click="newrecordContent()"
        >
          <w-icon class="mr1" xs>fal fa-plus</w-icon> Cipta
        </w-button>
      </template>
  
      <template #header-label="{ header, label, index }">
        <template v-if="header.key == 'action'">
        <w-icon>fal fa-pencil</w-icon>
        </template>
        <template v-else>
        {{ label }}
        </template>

  
      </template>
  
      <template #item-cell.filename="{ item, label, header, index }">
        <img :src="item.url" height="200" width="400">
      </template>
      <template #item-cell.status="{ item, label, header, index }">
        <template v-if="item.status == 1"> Aktif</template><template v-else>Tidak Aktif</template>
      </template>
  
      <template #item-cell.action="{ item, label, header, index }">
        <w-flex class="flex justify-center">
          <w-button class="bs fs-2" bg-color="primary-dark1" tile @click="editContent(item.id)">
            <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
          </w-button>
          <w-button class="fs-2" bg-color="error-dark1" dark tile @click="removePengumuman(item.id)">
            <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
          </w-button>
        </w-flex>
      </template>
  
    </z-table>
  
    </z-page>
    </zen-one>
  </template>
  
  <script>
  import ZResource from "@/Modules/z-resource-service";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  
  export default {
    extends: ZResource,
    props: {
      items: [Array, Object],
    },
    data() {
      return {
        resourceurl: this.service_ibayaq + "cms/service",
        editor: ClassicEditor,
        reload: true,
        crumbs: [
          { label: this.$page.props.app_name, route: '/sitemap' },
          // { label: 'Utama', route: '/' },
          { label: 'Pengurusan Ibayaq', route: '/ibayaq_cms/perkhidmatan_kami' },
          { label: 'Perkhidmatan Kami', route: '/ibayaq_cms/perkhidmatan_kami' }
        ],
        files : [],
        form: {
          id: 0,
          path: '',
          file: '',
          status: 1,
          url : ''
        },
        editorConfig: {
            width: '500px'
        },
      }
    },
    methods: {
        newrecordContent(){
            this.form = {
                id: 0,
                path: '',
                file: '',
                status: 1,
                url : ''
            };
            this.dialog.show = true;
        },
        editContent(id){
            this.loading = true;
            this.$zcomm.get(this.service_ibayaq + "cms/service/detail/" + id).then(resp => {
                this.form = resp;
                // this.form.sendtype = 'update';
            });
            this.dialog.show = true;
            this.loading = false;
            
        },
        submitContent(){
            this.loading = true;
            let formData = new FormData();
            if(this.files.length > 0){
              formData.append("file", this.files[0].file);
            }
            formData.append("id", this.form.id);
            formData.append("path", this.form.path);
            formData.append("status", this.form.status);
            console.log(this.form);
            this.$zcomm.post(this.service_ibayaq + "cms/service/simpan", formData)
            .finally(() => {
                this.dialog.loading = false;
                this.dialog.show = false;
                this.files = [];
                this.getData();

                // location.reload();
            });
            
        },
        removePengumuman(id){
            this.$zcomm.get(this.service_ibayaq + "cms/service/padam/" + id).then(resp => {
                location.reload();
            });
        },
    },
    watch: {
    },
    mounted() {
      // override default setting
      this.dialog.width = 500
  
    },
  }
  </script>
  